import React, { useState } from 'react';
import { Alert, AlertColor, Avatar, Box, Button, Container, Snackbar, Stack, TextField, Typography } from '@mui/material';
import AuthLegalNotice from '../../components/common/AuthLegalNotice/AuthLegalNotice';
import {
  authContainerStyling,
  authFormHeaderStyling,
  authFormPrimaryContainerStyling,
  authFormSecondaryContainerStyling,
  authHeaderContainerStyling,
  authHeaderTypographyStyling,
  authLogoStyling,
  authSecondaryContainerStyling,
  externalFormStyling,
} from '../../styles/sxStyling';
import { LockOutlined } from '@mui/icons-material';
import { useGetEventFormTemplateById } from '../../services/react-query/event_form_templates/useGetEventFormTemplateById';
import { useNavigate, useParams } from 'react-router-dom';
import { Loading } from '../../uikit';
import CustomAxios from '../../utility/customAxios';

type Response = {
  severity: AlertColor;
  message: string;
};

export default function FormAuthorizePassword() {
  const { uuid } = useParams();
  const navigate = useNavigate();
  const [response, setResponse] = useState<Response | null>(null);
  const [verificationCode, setVerificationCode] = useState<string>('');
  const { data: eventFormSubmission } = useGetEventFormTemplateById({ submission_uuid: uuid });

  if (!eventFormSubmission) return <Loading />;

  const handleSubmit = async () => {
    try {
      await CustomAxios.post(`form_submissions/${uuid}/authorize`, { verification_code: verificationCode });
      navigate(`/form/submit/${uuid}`);
    } catch (err: any) {
      setResponse({ severity: 'error', message: err?.response?.data?.error });
    }
  };

  // TODO check open/close dates and don't show form if outside

  return (
    <Container component="main" maxWidth="md" sx={authContainerStyling}>
      <title>ScheduLink | Studio Management Software for Volume Photo Studios</title>
      <Box sx={authSecondaryContainerStyling}>
        <Box sx={authHeaderContainerStyling}>
          <Stack direction="column" spacing={2}>
            <Typography variant="h1" sx={authHeaderTypographyStyling}>
              We sent you a form to complete.
            </Typography>
            <Typography variant="body1">Enter the one-time password we email you for secure access.</Typography>
          </Stack>
          {eventFormSubmission.organization_logo_url ? (
            <Box component="img" src={eventFormSubmission.organization_logo_url} alt={eventFormSubmission.organization_name} sx={authLogoStyling} />
          ) : (
            <Avatar>{eventFormSubmission.organization_name?.charAt(0)?.toUpperCase()}</Avatar>
          )}
        </Box>
        <Box sx={authFormPrimaryContainerStyling}>
          <Box sx={authFormSecondaryContainerStyling}>
            <Box sx={authFormHeaderStyling}>
              <Avatar sx={{ m: 1, bgcolor: 'primary.light' }}>
                <LockOutlined />
              </Avatar>
              <Typography variant="h5">Log In</Typography>
            </Box>
            <Box component="form" onSubmit={handleSubmit} noValidate sx={externalFormStyling}>
              <Box sx={{ display: 'flex' }}>
                <TextField required autoFocus label="Verification Code" value={verificationCode} onChange={(e) => setVerificationCode(e.target.value)} />
              </Box>
              <Box>
                <Button fullWidth variant="contained" onClick={handleSubmit} sx={{ mt: 3, mb: 2 }}>
                  Continue
                </Button>
                <AuthLegalNotice />
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
      <Snackbar open={!!response} onClose={() => setResponse(null)}>
        <Alert severity={response?.severity} sx={{ width: '100%' }}>
          {response?.message}
        </Alert>
      </Snackbar>
    </Container>
  );
}
